module.exports = __webpack_public_path__ + "static/img/project02.418ba08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/project02.jpg
// module id = Z9xh
// module chunks = 1